/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
import { useContext, useEffect, useRef } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

export function useBlocker(blocker: (tx: any) => void, when = true) {
  const navigator = useContext(NavigationContext).navigator as any;
  const isBlockedRef = useRef(false);
  const blockedTransactionRef = useRef<any>(null);

  useEffect(() => {
    if (!when) return;
    
    // Store original navigation functions
    const originalNavigate = navigator.navigate;
    const originalPush = navigator.push;
    const originalReplace = navigator.replace;
    
    // Create a blocking transaction object
    const createBlockingTransaction = (location: any, originalFn: (...args: any[]) => any, args: any[]) => ({
      location,
      retry: () => {
        isBlockedRef.current = false;
        blockedTransactionRef.current = null;
        originalFn.apply(navigator, args);
      },
      preventDefault: () => {
        // Navigation is already blocked, do nothing
      }
    });

    // Intercept the navigate function
    navigator.navigate = function(...args: any[]) {
      if (isBlockedRef.current) {
        const tx = createBlockingTransaction(args[0], originalNavigate, args);
        blockedTransactionRef.current = tx;
        blocker(tx);
        return;
      }
      
      // Allow navigation
      return originalNavigate.apply(navigator, args);
    };

    // Intercept push if it exists
    if (originalPush) {
      navigator.push = function(...args: any[]) {
        if (isBlockedRef.current) {
          const tx = createBlockingTransaction(args[0], originalPush, args);
          blockedTransactionRef.current = tx;
          blocker(tx);
          return;
        }
        return originalPush.apply(navigator, args);
      };
    }

    // Intercept replace if it exists
    if (originalReplace) {
      navigator.replace = function(...args: any[]) {
        if (isBlockedRef.current) {
          const tx = createBlockingTransaction(args[0], originalReplace, args);
          blockedTransactionRef.current = tx;
          blocker(tx);
          return;
        }
        return originalReplace.apply(navigator, args);
      };
    }

    // Enable blocking
    isBlockedRef.current = true;

    // Also handle page refresh/close
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      // Restore original functions
      navigator.navigate = originalNavigate;
      if (originalPush) {
        navigator.push = originalPush;
      }
      if (originalReplace) {
        navigator.replace = originalReplace;
      }
      
      // Reset blocking state
      isBlockedRef.current = false;
      blockedTransactionRef.current = null;
      
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [navigator, blocker, when]);

  // Return a function to manually reset the blocking state
  return () => {
    isBlockedRef.current = false;
    blockedTransactionRef.current = null;
  };
}
